module.exports = __webpack_public_path__ + "img/bell_5.4b0170e4.jpg";